import { render } from "./BCheckbox.vue?vue&type=template&id=091f6bbd&scoped=true"
import script from "./BCheckbox.vue?vue&type=script&lang=js"
export * from "./BCheckbox.vue?vue&type=script&lang=js"

import "./BCheckbox.vue?vue&type=style&index=0&id=091f6bbd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091f6bbd"]])

export default __exports__